/// <reference path="ILogger.ts" />

/**
 * Easy-access methods for logging.
 */
namespace RS.Log
{
    /**
     * Logs a debug message.
     * @param message 
     */
    export function debug(message: string)
    {
        Logging.ILogger.get().log(message, Logging.LogLevel.Debug);
    }

    /**
     * Logs an informative message.
     * @param message 
     */
    export function info(message: string)
    {
        Logging.ILogger.get().log(message, Logging.LogLevel.Info);
    }

    /**
     * Logs an warning message.
     * @param message 
     */
    export function warn(message: string)
    {
        Logging.ILogger.get().log(message, Logging.LogLevel.Warn);
    }

    /**
     * Logs an error message.
     * @param message 
     */
    export function error(message: string)
    {
        Logging.ILogger.get().log(message, Logging.LogLevel.Error);
    }
}